import * as React from 'react';
import {AppUser} from 'Src/views/App/App';
import {SchoolEvent} from 'Src/models/event';
import {saveMatchLabel} from 'Src/helpers/service/admin/eventResults';
import './EventMatchLabel.scss';

export function EventMatchLabel({event, user, onSaved, onEditingChange}: {event: Partial<SchoolEvent>; user?: AppUser; onSaved?: (saved: any) => void; onEditingChange?: (editing: boolean) => void}) {
  const [editing, setEditing] = React.useState(false), [label, setLabel] = React.useState('');
  const [busy, setBusy] = React.useState(false), [error, setError] = React.useState('');
  const canEdit = user && event.sourceEventId && String(event.inviterSchoolId) === String(user.activeSchoolId);
  if (!editing) {return <span className="eventMatchLabel">
    {event.sourceMatchLabel}
    {canEdit && <button type="button" onClick={() => {setLabel(event.sourceMatchLabel || ''); setError(''); setEditing(true); onEditingChange?.(true);}}>
      {event.sourceMatchLabel ? 'Edit match label' : 'Add match label'}
    </button>}
  </span>;}
  return <div className="eventMatchLabel">
    <label>Match label <input className="form-control" maxLength={100} value={label} disabled={busy} onChange={e => setLabel(e.target.value)} /></label>
    <button type="button" disabled={busy} onClick={async () => {
      setBusy(true); setError('');
      try {const saved = await saveMatchLabel(user, event.id, label, event.sourceMatchLabel || ''); onSaved?.(saved); setEditing(false); onEditingChange?.(false);}
      catch (e: any) {setError(e?.response?.data?.details?.text || e?.response?.data?.message || e.message);}
      finally {setBusy(false);}
    }}>{busy ? 'Saving…' : 'Save label'}</button>
    <button type="button" disabled={busy} onClick={() => {setEditing(false); onEditingChange?.(false);}}>Cancel</button>
    {error && <span role="alert">{error}</span>}
  </div>;
}
